import { render, staticRenderFns } from "./SurfacePostCommentsIcon.vue?vue&type=template&id=ffb386b6&"
import script from "./SurfacePostCommentsIcon.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostCommentsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports